<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Funny</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/funnies" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateFunny" v-if="funny">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="funny.funnyName"
                                  label="Funny Title"
                                  placeholder="Enter Funny Title"
                                  v-validate="rules.funnyName"
                                  data-vv-name="Title"
                                  cus-name="Title"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="funny.funnyUrl"
                                  v-validate="rules.funnyUrl"
                                  label="Image URL"
                                  placeholder="Enter Image URL"
                                  data-vv-name="Image URL"
                                  cus-name="Image URL"
                                  :has-errors="errors"
                                  :is-fields="fields"
                                  >
                        </fg-input>
                      </div>
                      <div class="col-12" v-if="corps.length">
                        <multiselect
                          v-model="funny.csvCorporationId"
                          placeholder="Select Corporation"
                          :multiple="true"
                          :taggable="true"
                          :options="corps.map(type => type.corporationId)"
                          :custom-label="opt => corps.find(x => x.corporationId == opt).name"
                          required>
                          >
                        </multiselect>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="funny.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Funny
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditFunny',
        created (){
          this.fetchCorporations();
        this.$store.dispatch('GETSELECTEDFUNNY', this.$route.params.id).then(() =>{
            this.funny = this.selectedFunny;
          this.funny.csvCorporationId = this.funny.csvCorporationId.split(',')
        })
    },
    data () {
        return {
            funny: this.selectedFunny || {},
          rules: {
            funnyName: {required : true},
            funnyUrl: {required : true},
            active: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          corps:[],
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        updateFunny () {
          this.$validator.validateAll().then((result) => {
            if(result){

              let updateFunny = () =>{
                this.$store.dispatch('UPDATE_FUNNY', this.funny)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'Funny is successfully updated', 'success', ()=>this.$router.push('/admin/funnies'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_Funny API error : ", err);
                  })
              };
              updateFunny();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'funnies', 'selectedFunny']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Funnies/EditFunny.vue